import * as React from 'react';
import './css/App.css';
import './css/bootstrap.min.css';
import bootstrap from 'bootstrap'
import LoginForm from './LoginForm';
import DashBoard from './DashBoard';
import OrderslList from './cookies/OrdersList';
import PoEditor from './cookies/PoEditor';
import AddVendor from './vendors/AddVendor';
import AllVendors from './vendors/AllVendors';

import { ToastContainer } from 'react-toastify';


import {
	Route,
	Link,
	Redirect,
	Switch,
	BrowserRouter as Router,
} from 'react-router-dom';
import Template from './cookies/Template';

// import UpdateVendor from './vendors/UpdateVendor';

class App extends React.Component {

	//This is the constructor of a component, here you can find the state of this component
	constructor(props) {
		super(props);
		this.state = {
			isLoggedIn: false,
			username: "",
			permissions: [],
			loginMessage: ""
		}
		this.loginResults = this.loginResults.bind(this);
		this.loginButton = this.loginButton.bind(this);
		this.loginInfo = React.createRef();
	}

	//Process the result from Login SQL query
	loginResults = (data) => {
		//Checks if the username and password were correct
		//if is not, it will show a message for the user
		if (data == "Username or Password not correct") { this.setState({ loginMessage: data }) }
		//if it is correct converts the string into an JSON and store information into the state
		else {
			data = JSON.parse(data)
			this.setState({ username: data.username })
			let permissionsRes = data.permissions.split(',');
			this.setState({ permissions: permissionsRes })
			this.setState({ loginMessage: "Login successful" })
			this.setState({ isLoggedIn: true })
		}
	}

	//Login button function
	loginButton = async (e) => {
		e.preventDefault();

		//This retrieves the information (state) from the LoginForm Component 
		const loginFormInput = this.loginInfo.current;
		let login = loginFormInput.state.username;
		let pass = loginFormInput.state.password;

		//This send the data from the form to the database and checks if username exists and if password is correct
		var formdata = new FormData();
		formdata.append("username", login);
		formdata.append("password", pass);

		var requestOptions = {
			method: 'POST',
			body: formdata,
			redirect: 'follow'
		};

		let objResults = {};

		fetch("https://dashboard.realsexdoll.info/php/login.php", requestOptions)
			.then((response) => response.text())
			.then((data) => this.loginResults(data))
			.catch(error => console.log('error', error));
	}


	//This runs when the dashboard opens
	componentDidMount() {

		//Changes the title the page for Dashboard
		document.title = "Dashboard";

	}

	//Renders the final result of the plataform
	render() {
		//Checks if the user is logged in if not it will render the login form
		const isLoggedIn = this.state.isLoggedIn;
		let loginForm;
		let dashboard;
		if (!isLoggedIn) {
			loginForm = <LoginForm ref={this.loginInfo} loginButton={this.loginButton} infoMessage={this.state.loginMessage} />
		} else {
			dashboard = <DashBoard user={this.state.username} permissions={this.state.permissions} />
		}

		return (
			<div className="App">
				<ToastContainer></ToastContainer>
				<Router>
					<Switch>
						<Route exact path="/">
							{!this.state.isLoggedIn ? (
								<LoginForm ref={this.loginInfo} loginButton={this.loginButton} infoMessage={this.state.loginMessage} />
							) : (
								<DashBoard user={this.state.username} permissions={this.state.permissions} />
							)}
						</Route>
						<Route exact path="/cookies/orderslist" component={OrderslList} />
						<Route exact path="/cookies/poeditor" component={PoEditor} />
						<Route exact path="/vendors/vendor" component={AddVendor}/>
						<Route exact path="/vendors/vendorlist" component={AllVendors}/>
						
						<Route exact path="/templates" component={Template}/>
					</Switch>
				</Router>
			</div>
		);
	}
}

export default App;
